import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Dropdown, Menu, Drawer, Button, Space, notification } from "antd";
import Pagination from "@mui/material/Pagination";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsDown, faThumbsUp, faTrash, faEllipsis, faCloudDownload, faBan, faCheckCircle, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

import TobNavBar from "../../DashBaord/Top_navbar";
import ShowData from "../../../components/ShowData";
import { Link, useNavigate, useLocation } from "react-router-dom";

import moment from "moment";
import SkeltonList from "../../../components/SkeltonEffect/list";
import { list, deleteData, changeStatus, deleteBatch, bulkChangeStatus, bulkDeleteData } from "../../../controllers/V1/lottoWinners/lottoWinnersControllers";
import { getPage, statusMessage, formatProjectDate } from "../../../controllers/common";
import * as XLSX from 'xlsx';

function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};



export default function BasicTabs() {
  const location = useLocation();
  const state = location.state;
  const [batchData, setbatchData] = useState(state || {})
  const [isFilterShow, setFilterShow] = useState(false);
  const handleFiterDrawer = () => setFilterShow(!isFilterShow);
  /************************************************************************************* */
  const [isLoading, setIsLoading] =useState(true);
  const navigate = useNavigate();
  const targetRef = useRef(null);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [ALLLISTDATA, setListData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(10);
  const [SKIP, setSkip] = useState(0);
  const [filter, setFilter] = useState({
    from: "",
    to: new Date(),
    filter_by: "",
    search: "",
  }); //End

  const [showRequest, setShowRequest] = useState("");

  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        type: "",
        condition: {
          batch_id : batchData?.batch_id,
          ...(filter?.filter_by === 'order_no'?{order_no : filter?.search }:null),
          ...(filter?.filter_by === 'coupon_code'?{coupon_code : filter?.search }:null),
          ...(filter?.filter_by === 'title'?{title : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter?.filter_by === 'name'?{name : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter?.filter_by === 'mobile'?{mobile : parseInt(filter?.search) }:null),
          ...(filter?.filter_by === 'prize'?{prize : { $regex: filter?.search, $options: "i" } }:null),
          
          ...(filter?.from?{createdAt : {$gte : new Date(`${filter.from} 0:01:00`), $lte : new Date(`${filter.from} 23:59:00`)} }:null),
          ...(showRequest ? { status: showRequest } : null),
        },
        select: {},
        sort: { winning_amount : -1, status: 1, _id: -1 },
        skip: SKIP ? SKIP : 0,
        limit: LIMIT ? LIMIT : 10,
      };
      const listData = await list(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
          setTotalPages(getPage(listData?.count, LIMIT))
        } else {
          setListData([]);
          setTotalPages(getPage(1))
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  /*********************************************************
   *  This function is ued for handle filter input change
   *********************************************************/
  const handleFilterReset = () => {
    try {
      setFilter('');
      inputRef1.current.value = '';
      inputRef2.current.value = '';
      inputRef3.current.value = '';
      inputRef4.current.value = '';
    } catch (error) {
      
    }
  }

  const handleFilterApply = (e) => {
    try {
      e.preventDefault();
      const form = new FormData(e.target);
      setFilter((pre)=>({
        ...pre,
        'filter_by' : form.get('filter_by') || '',
        'search'    : form.get('search') || '',
        'to'        : form.get('to_date') || '',
        'from'      : form.get('from_date') || '',

      }))
      // console.log('filter',filter);
      // alert('submit');
      handleFiterDrawer();
      setSkip(0);
    } catch (error) {
      
    }
  }

  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    getList();
    targetRef.current.scrollIntoView({
      behavior:'smooth',
    });
    document.title = "Orbit Kuwait || Lotto Winner's list";
  }, [currentPage, showRequest, filter, LIMIT]);

  const handleChangeStatus = async (id = '', status = '') =>{
    try {
      if(!id){
        notification.open({
          message: "Oops!",
          description: `Data not found.`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
      } else if(!status){
        notification.open({
          message: "Oops!",
          description: `Status not pass.`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
      } else {
        const option ={ id : id, status : status };
        const res = await changeStatus(option);
        if(res.status === true){
          getList();
          notification.open({
            message: "Success",
            description: `Data updated successfully..`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faCheckCircle} style={{ color: "green" }} />,
            duration: 2,
          });
        } else {
          notification.open({
            message: "Oops!",
            description: `${res.message}`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
            duration: 2,
          });
        }
      }
    } catch (error) {
      
    }
  }


  const handleDelete = async (id = '') =>{
    try {
      if(!id){
        notification.open({
          message: "Oops!",
          description: `Id not found.`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
      } else {
        const option ={ id : id };
        const res = await deleteData(option);
        if(res.status === true){
          getList();
          notification.open({
            message: "Success",
            description: `Data delete successfully.`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faCheckCircle} style={{ color: "green" }} />,
            duration: 2,
          });
        } else {
          notification.open({
            message: "Oops!",
            description: `${res.message}`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
            duration: 2,
          });
        }
      }
    } catch (error) {
      notification.open({
        message: "Oops!",
        description: `Error while procession`,
        placement: "topRight",
        icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
        duration: 2,
      });
    }
  }

const toggleSelect = (item_id) =>{
  try {
    const updatedData = ALLLISTDATA.map((item) => ({
      ...item,
      selected: item._id === item_id ? !item.selected : item.selected
    }));
    setListData(updatedData);
  } catch (error) {
    
  }
}

const handleSelectAll = () =>{
  try {
    const updatedData = ALLLISTDATA.map((item) => ({
      ...item,
      selected: true
    }));
    setListData(updatedData);
  } catch (error) {
    
  }
}

const handleClear = () =>{
  try {
    const updatedData = ALLLISTDATA.map((item) => ({
      ...item,
      selected: false
    }));
    setListData(updatedData);
  } catch (error) {
    
  }
}

const handleDeleteBatch = async () => {
  try {
    const id = batchData.batch_id;
    if(!id){
      notification.open({
        message: "Oops!",
        description: `Id not found.`,
        placement: "topRight",
        icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
        duration: 2,
      });
    } else {
      const option ={ ids_list : [id] };
      const res = await deleteBatch(option);
      if(res.status === true){
        notification.open({
          message: "Success",
          description: `Data delete successfully.`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faCheckCircle} style={{ color: "green" }} />,
          duration: 2,
        });
        navigate('/lotto-winners/list');
      } else {
        notification.open({
          message: "Oops!",
          description: `${res.message}`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
      }
    }
  } catch (error) {
    notification.open({
      message: "Oops!",
      description: `Error while procession`,
      placement: "topRight",
      icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
      duration: 2,
    });
  }
}

const handleBulkInactive = async () =>{
  try {
    const selectedIds = ALLLISTDATA.reduce((acc, item) => {
      if (item.selected === true) acc.push(item._id);
      return acc;
    }, []);
    if(selectedIds?.length > 0){
      const option = { 
        ids_list : selectedIds,
        status : "Inactive"
      }
      const res = await bulkChangeStatus(option);
      if(res.status === true){
        notification.open({
          message: "Success",
          description: `Data updated successfully.`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faCheckCircle} style={{ color: "green" }} />,
          duration: 2,
        });
        getList();
      } else {
        notification.open({
          message: "Oops!",
          description: `${res.message}`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
      }
    } else {
      notification.open({
        message: "Oops!",
        description: `Please select winner.`,
        placement: "topRight",
        icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
        duration: 2,
      });
    }
  } catch (error) {
    
  }
}

const handleBulkActive = async () =>{
  try {
    const selectedIds = ALLLISTDATA.reduce((acc, item) => {
      if (item.selected === true) acc.push(item._id);
      return acc;
    }, []);
    if(selectedIds?.length > 0){
      const option = { 
        ids_list : selectedIds,
        status : "Active"
      }
      const res = await bulkChangeStatus(option);
      if(res.status === true){
        notification.open({
          message: "Success",
          description: `Data updated successfully.`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faCheckCircle} style={{ color: "green" }} />,
          duration: 2,
        });
        getList();
      } else {
        notification.open({
          message: "Oops!",
          description: `${res.message}`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
      }
    } else {
      notification.open({
        message: "Oops!",
        description: `Please select winner.`,
        placement: "topRight",
        icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
        duration: 2,
      });
    }
  } catch (error) {
    
  }
}

const handleBulkDelete = async () =>{
  try {
    const selectedIds = ALLLISTDATA.reduce((acc, item) => {
      if (item.selected === true) acc.push(item._id);
      return acc;
    }, []);
    if(selectedIds?.length > 0){
      const option = { ids_list : selectedIds }
      const res = await bulkDeleteData(option);
      if(res.status === true){
        notification.open({
          message: "Success",
          description: `Data deleted successfully.`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faCheckCircle} style={{ color: "green" }} />,
          duration: 2,
        });
        getList();
      } else {
        notification.open({
          message: "Oops!",
          description: `${res.message}`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
      }
    } else {
      notification.open({
        message: "Oops!",
        description: `Please select winner.`,
        placement: "topRight",
        icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
        duration: 2,
      });
    }
  } catch (error) {
    
  }
}

const handleExportExcel = async () => {
  try {
    setIsLoading(true);
    const options = {
      condition : { batch_id : batchData?.batch_id},
      sort: { winning_amount : -1, status: 1, _id: -1 },
      limit : 0,
      skip : 0
    }
    const res = await list(options);
      if (res.status === true) {
        if(res.result.length > 0){
          let modifiedData = res?.result.map(({ _id, redeem_date, ...rest }) => ({
            // ...rest,
            "Batch ID" : rest?.batch_id,
            "Order No" : rest?.order_no,
            "Seller First Name" : rest?.seller_first_name,
            "Seller Last Name" : rest?.seller_last_name,
            "Seller Mobile" : rest?.seller_mobile,
            "Coupons" : rest?.coupon_code,
            "Matching Code" : rest?.matching_code,
            "Winner Type" : rest?.winner_type,
            "Winning Amount" : rest?.winning_amount,
            "Status" : rest?.status,
            "Redeem Name" : rest?.redeem_name,
            "Redeem POS" : rest?.redeem_pos,
            ...(redeem_date && {'Redeem Date' : moment(formatProjectDate(redeem_date)).format('DD-MM-YYYY hh:mm A') || ''})
          }));
          await exportToExcel(modifiedData, batchData?.file); 
        }
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Export Error:", error);
    }
}
const exportToExcel = async (data, fileName = "Winner List") => {
  try {
    const workbook = XLSX.utils.book_new();
    const worksheet1 = XLSX.utils.json_to_sheet(data);

    XLSX.utils.book_append_sheet(workbook, worksheet1, "Due");
    XLSX.writeFile(workbook, `${fileName}`);
  } catch (error) {
    alert("Error generating Excel file: " + error.message);
  } finally {
    setIsLoading(false);
  }
};

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={`Winner's list`}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                  <ShowData setLimit={setLimit} limit={LIMIT}/>
                </div>
                <div className="all_tabs_value">
                  <button type="button" className="form-control store_input_field" onClick={handleSelectAll}>Select All</button>
                </div>

                <div className="all_tabs_value">
                  <button type="button" className="form-control store_input_field" onClick={handleClear}>Clear</button>
                </div>


                <div className="all_tabs_value">
                  <button type="button" className="form-control store_input_field" onClick={handleBulkInactive}>Bulk Inactive</button>
                </div>

                <div className="all_tabs_value">
                  <button type="button" className="form-control store_input_field" onClick={handleBulkActive}>Bulk Active</button>
                </div>

                <div className="all_tabs_value">
                  <button type="button" className="form-control store_input_field" disabled={isLoading} onClick={handleExportExcel}>{isLoading?'Preparing Data':'Export All' }</button>
                </div>

                {/* <div className="all_tabs_value">
                  <button type="button" className="form-control store_input_field" onClick={handleBulkDelete}>Bulk Delete</button>
                </div> */}

                {/* <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                  <button type="button" className="form-control store_input_field" onClick={handleDeleteBatch}>Delete Batch</button>
                </div> */}
              </div>
              <br/>
              <div className="inventory_all_tabs">
                
                <div className="all_tabs_value">
                  <label htmlFor="name" className="all_section_for_label_main_class" > Batch Nos. : {`${batchData?.batch_id}`}</label>
                </div>

                <div className="all_tabs_value">
                  <label htmlFor="name" className="all_section_for_label_main_class" > Winners Nos. : {`${batchData?.orderCount}`}</label>
                </div>

                <div className="all_tabs_value">
                  <label htmlFor="name" className="all_section_for_label_main_class" > Winners Amount : {`${batchData?.total_points}`}</label>
                </div>

                <div className="all_tabs_value">
                  <label htmlFor="name" className="all_section_for_label_main_class" > Winners Redeemed : {`${batchData?.redeemedPoints}`}</label>
                </div>

                <div className="all_tabs_value">
                  <label htmlFor="name" className="all_section_for_label_main_class" > Winners Unpaid : {parseFloat(batchData?.total_points) - parseFloat(batchData?.redeemedPoints)}</label>
                </div>
              </div>
            </Box>       
            <VendorList 
              >
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      <div className="table-responsive">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellspacing="0"
                        >
                          <thead>
                            <tr>
                              <th>Sl. No.</th>
                              <th>Order No.</th>
                              <th>Seller's Details</th>
                              <th>Coupon Code</th>
                              <th>Matching Code</th>
                              <th>Game Type</th>
                              <th>Winner Type</th>
                              <th>Winning Amount</th>
                              <th>Created Date & Time</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ALLLISTDATA?.length > 0 ? (
                              ALLLISTDATA.map((items, index) => (
                                <>
                                  <tr key={index} onClick={()=>toggleSelect(items._id)} >
                                    <td>
                                      <input type="checkbox" checked={items?.selected === true} className="form-check-input"/>
                                      {" "}{SKIP + index + 1}
                                    </td>
                                  
                                    {items.status === 'Redeemed' ? (
                                      <td>{items?.order_no}</td>
                                    ):(
                                      <td>{`EDDCXXXXXXXXXXXXXX`}</td>
                                    )}
                                  
                                    <td>
                                      Name : {`${items?.seller_first_name} ${items?.seller_last_name}`} <br/>
                                      Ph. No : {items?.seller_mobile}
                                    </td>

                                    <td>{items?.coupon_code}</td>
                                    <td>{items?.matching_code}</td>
                                    <td>
                                      {items?.straight_amount > 0 && 'Straight'}
                                      {items?.rumble_amount > 0 && 'Rumble'}
                                      {items?.chance_amount > 0 && 'Chance'}
                                    </td>
                                    <td>{items?.winner_type || 'N/A'}</td>
                                    <td>
                                      {items?.winning_amount?.toFixed(2) || 0}
                                    </td>
                                    <td>{moment(items?.createdAt).format('DD-MM-YYYY h:mm A')}</td>
                                    <td><span dangerouslySetInnerHTML={{__html: statusMessage(items?.status)}}></span></td>
                                    <td>
                                      <Dropdown
                                        placement="bottomLeft"
                                        arrow
                                        overlay={
                                          <Menu>
                                            {(items.status === 'Inactive') && (
                                              <Menu.Item key={`2`} onClick={()=>handleChangeStatus(items._id,'Active') } >
                                                <FontAwesomeIcon icon={faThumbsUp} /> <span className="show_span">Active</span>
                                              </Menu.Item>
                                            )}
                                            {items.status === 'Active' && (
                                              <Menu.Item key={`3`} onClick={() => handleChangeStatus(items._id,'Inactive')} >
                                                <FontAwesomeIcon icon={faThumbsDown} /> <span className="show_span">Inactive</span>
                                              </Menu.Item>
                                            )}
                                            {/* <Menu.Item key={`4`} onClick={() => handleDelete(items._id)} >
                                              <FontAwesomeIcon icon={faTrash} /> <span className="show_span">Delete</span>
                                            </Menu.Item> */}
                                          </Menu>
                                        }
                                      >
                                        <FontAwesomeIcon icon={faEllipsis} />
                                      </Dropdown>
                                    </td>
                                  </tr>
                                </>
                              ))
                            ) : isLoading ? <SkeltonList row={5} col={11} /> : <tr> 
                                <td colspan="11" className="img-center" >No data found !</td> 
                            </tr>}
                          </tbody>
                        </table>
                        <div className="table_pagination_sales_order">
                          <Pagination
                            count={TOTALPAGES}
                            onChange={handlePageChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
      
      {/* Filter */}
      <Drawer
        title="Filter"
        placement={`right`}
        width={500}
        onClose={handleFiterDrawer}
        open={isFilterShow}
        extra={
          <Space>
            <Button onClick={handleFiterDrawer}>Cancel</Button>
            <Button type="primary" onClick={handleFilterReset}  style={{ backgroundColor: 'red', color: 'white' }}>
              Reset
            </Button>
          </Space>
        }
      >
        <div className="responsive">
          <div className="row">
            <form id='filter_form' onSubmit={handleFilterApply}>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Field :
                </label>
                <select name="filter_by" className="form-control store_input_field" id="filter_by" ref={inputRef1}>
                  <option value='' selected disabled>Select search field</option>
                  <option value='order_no' selected={filter?.filter_by ==='order_no'?true:false}>Order number</option>
                  <option value='coupon_code' selected={filter?.filter_by ==='coupon_code'?true:false}>Coupon code</option>
                  <option value='title' selected={filter?.filter_by ==='title'?true:false}>Title</option>
                  <option value='name' selected={filter?.filter_by ==='name'?true:false}>Name</option>
                  <option value='mobile' selected={filter?.filter_by ==='mobile'?true:false}>Mobile</option>
                  <option value='prize' selected={filter?.filter_by ==='prize'?true:false}>Prize</option>
                </select>
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Text :
                </label>
                <input
                  title="Enter search text."
                  placeholder="Enter search text."
                  type="text"
                  name="search"
                  className="form-control store_input_field"
                  id="search"  
                  ref={inputRef2}
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  From :
                </label>
                <input
                  title="Enter search text."
                  type="date"
                  name="from_date"
                  className="form-control store_input_field"
                  id="from_date"      
                  ref={inputRef3}
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  To :
                </label>
                <input
                  title="Enter search text."
                  type="date"
                  name="to_date"
                  className="form-control store_input_field"
                  id="to_date"   
                  ref={inputRef4}
                />
              </div>
              <br/>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button
                  title="Enter search text."
                  type="submit"
                  className="form-control btn btn-black"    
                  style={{ backgroundColor: "black", color: "white" }}           
                >Apply</button>
              </div>
            </form>
          </div>
        </div>
      </Drawer>
    </>
  );
}
